<template>
  <div id="contenedor-contratistas-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            v-on:buscar="buscar">
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :listadoContratistas="getContratistas">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-if="esteContratista"
      v-model="mostrarVentanaEditarContratista"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
      <editar-contratista
        :contratistaEditar="esteContratista"
        v-on:cerrar="cerrarEditarContratista">
      </editar-contratista>
    </v-dialog>
    <v-dialog
      v-if="esteContratista"
      v-model="mostrarVentanaEliminarContratista"
      :width="!$vuetify.breakpoint.xs ? '450' : '90%'">
      <eliminar-contratista
        :contratistaEliminar="esteContratista"
        v-on:cerrar="cerrarRemoverContratista">
      </eliminar-contratista>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATISTAS from '@/graphql/querys/administracion/catalogos/contratistas/contratistas.gql';
import TituloToolBar from './TituloToolBar.vue';
import EditarContratista from '@/components/administracion/configuracion/catalogos/contratistas/Editar.vue';
import EliminarContratista from '@/components/administracion/configuracion/catalogos/contratistas/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratistaDefault',
  components: {
    TituloToolBar,
    EditarContratista,
    EliminarContratista,
    ToolBar,
    Listado,
  },
  data() {
    return {
      buscarTexto: '',
      mostrarVentanaEditarContratista: false,
      mostrarVentanaEliminarContratista: false,
      esteContratista: null,
    };
  },
  mounted() {
    eventBus.$on('editar-contratista', (contratista) => {
      this.esteContratista = contratista;
      this.mostrarVentanaEditarContratista = true;
    });
    eventBus.$on('eliminar-contratista', (contratista) => {
      this.esteContratista = contratista;
      this.mostrarVentanaEliminarContratista = true;
    });
  },
  methods: {
    buscar(buscarTexto) {
      this.buscarTexto = buscarTexto;
    },
    cerrarEditarContratista() {
      this.mostrarVentanaEditarContratista = false;
      this.esteContratista = null;
    },
    cerrarRemoverContratista() {
      this.mostrarVentanaEliminarContratista = false;
      this.esteContratista = null;
    },
  },
  apollo: {
    contratistas: {
      query: CONTRATISTAS,
    },
  },
  computed: {
    getContratistas() {
      if (!this.contratistas) return [];
      return this.contratistas
        .filter((contratista) => {
          if (!this.buscarTexto) return contratista;
          const expt = new RegExp(this.buscarTexto, 'gi');

          const rfc = this.$normalizacionTexto(contratista.rfc);
          const nombreRazonSocial = this.$normalizacionTexto(contratista.nombreRazonSocial);
          const nombreRepresentante = this.$normalizacionTexto(contratista.nombreRepresentante);
          const correoElectronico = this.$normalizacionTexto(contratista.correoElectronico);

          return (
            expt.test(rfc)
            || expt.test(nombreRazonSocial)
            || expt.test(nombreRepresentante)
            || expt.test(correoElectronico)
            || expt.test(contratista.rfc)
            || expt.test(contratista.nombreRazonSocial)
            || expt.test(contratista.nombreRepresentante)
            || expt.test(contratista.correoElectronico)
          );
        })
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
};
</script>

<style lang="scss">

</style>
